<div class="relative">
  @if (webshopService.productCount(); as count) {
    @if (count > 0) {
      <div @popIn class="noti-dot-count">
        <span class="fa-stack small">
          <i class="fas fa-circle fa-stack-2x" style="color: var(--p-red-500)"></i>
          @if (count > 9) {
            <i [class]="'fa-stack-1x fas fa-exclamation'" style="color: white"></i>
          }
          @if (count <= 9) {
            <i [class]="'fa-stack-1x fas fa-' + count" style="color: white"></i>
          }
        </span>
      </div>
    }
  }
  <ui-button icon="far fa-shopping-cart" [rounded]="true" (clicked)="toSSPShoppingCart()" />
</div>
